import { guideRowHtml } from "./component.js";
const scalarRow = {
  name: "scalar-row",
  tagName: "scalar-row",
  tiptapName: "scalar-row",
  attributeTransform: (_, attrs) => {
    return {
      classes: "",
      cols: attrs.cols ? Number(attrs.cols) : void 0
    };
  },
  render: async (props) => {
    const transformed = scalarRow.attributeTransform("", props);
    return transformed ? guideRowHtml(transformed) : "";
  }
};
export {
  scalarRow
};
//# sourceMappingURL=index.js.map
